export default function LoaderSkeleton({ els = 4 }) {
	const printEls = [];
	for (let m = 0; m < els; m++) {
		printEls.push(
			<div
				key={m}
				className="h-4 w-4 animate-pulse rounded-full bg-dark-100 dark:bg-dark-700"
			/>
		);
	}
	return (
		<div className="absolute inset-0 z-50 flex gap-2 bg-white p-4 dark:bg-dark-950">
			<div className="flex-1 animate-pulse rounded-lg bg-dark-100 dark:bg-dark-700" />
			{printEls}
		</div>
	);
}
